import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import './styles/index.scss';
import { Provider } from 'react-redux';
import store from './app/store';
import { queryClient } from './app/queryClient';
import { installFormioCalendarIconFix } from './features/Forms/utils/formioCalendarIconFix';
import { registerFormioBootstrap5Template } from './features/Forms/utils/registerFormioTemplate';

registerFormioBootstrap5Template();
installFormioCalendarIconFix();

// Service Worker registration is handled by PWAUpdateDialog component
// using virtual:pwa-register/react for React integration with update UI

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);
